import React from "react"
import * as api from "brandguard/api"
import GenerateCorrectionShared from "brandguard/components/generate.correction"

interface props {
	items: api.VideoSearchResponseItem[]
	onCorrectionComplete?: () => void
}

export default function GenerateCorrection(props: props): JSX.Element {
	return <GenerateCorrectionShared items={props.items} corrections={api.videos.corrections} progressLabel="video" onCorrectionComplete={props.onCorrectionComplete} />
}
